<ag-grid-angular
    class="ag-theme-alpine"
    style="width: 100%; height: 100%;"
    [gridOptions]="gridOptions()"
    [columnDefs]="columnDefs()"
    [rowData]="rowData()"
    [rowSelection]="rowSelectionBuilder()"
    (selectionChanged)="onSelectionChanged($event)"
    (rowDragEnd)="onRowDragEnd($event)"
    (rowDragCancel)="onRowDragCancel()"
    (rowDragMove)="onRowDragMove($event)"
    (rowDataUpdated)="onRowDataUpdated($event)"
    (rowClicked)="onRowClicked.emit($event.data)"
    (gridReady)="onGridReady($event)"
/>
